import { Link } from 'react-router-dom';

interface PlatformCardProps {
  id: string;
  name: string;
  category: string;
  description: string;
  features: string[];
  rating: number;
  imageUrl: string;
  websiteUrl: string;
  articleSlug: string;
}

export default function PlatformCard({
  name,
  description,
  features,
  rating,
  imageUrl,
  websiteUrl,
  articleSlug,
}: PlatformCardProps) {
  const renderStars = (rating: number) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating - fullStars >= 0.5;
    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={`full-${i}`} className="ri-star-fill text-accent-500 text-sm"></i>);
    }
    if (hasHalf) {
      stars.push(<i key="half" className="ri-star-half-fill text-accent-500 text-sm"></i>);
    }
    const remaining = 5 - fullStars - (hasHalf ? 1 : 0);
    for (let i = 0; i < remaining; i++) {
      stars.push(<i key={`empty-${i}`} className="ri-star-line text-accent-300 text-sm"></i>);
    }
    return stars;
  };

  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group hover:border-primary-200 transition-all duration-300">
      <div className="relative h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 right-3 bg-background-50/90 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-1">
          <span className="text-sm font-semibold text-foreground-900">{rating}</span>
          <i className="ri-star-fill text-accent-500 text-xs"></i>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-heading font-semibold text-foreground-900 mb-2">{name}</h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">{description}</p>
        <div className="flex flex-wrap gap-1.5 mb-4">
          {features.slice(0, 4).map((feature) => (
            <span key={feature} className="text-xs px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 whitespace-nowrap">
              {feature}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <a
            href={websiteUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex-1 text-center px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            访问平台
          </a>
          <Link
            to={`/article/${articleSlug}`}
            className="px-4 py-2 rounded-lg border border-background-200 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            详细评测
          </Link>
        </div>
      </div>
    </div>
  );
}